// ── An account name as the Lease section keeps it (report 4c63e9a1, opening #6) ──────────────────
// The reporter: "With the name or company name do not allow all caps and always use 'Company Limited'
// in full or 'Partnership Limited' in full rather than 'Co., Limited' and 'Part. Limited'." The Lease
// section's Account name box runs this as it is left, and a lease document's reading before the box
// sees it (server/src/services/propertyForm.ts accountNameInFull, which the Lease Agreement prints the
// box through too — keep the two in step):
//   · a name written wholly in capitals is written in capitalised words — "SAWASDEE POOL VILLA" →
//     "Sawasdee Pool Villa" (utils/personName.ts, the person-name rule: "O'NEIL" → "O'Neil", the
//     workspace's own word in capitals kept); a name with any small letter is left as typed, so "ABC
//     Trading" keeps its initials and can be retyped that way;
//   · the three English legal forms the company-name reading writes out (report 21148c83, the same
//     regexes) are written out here too, whatever the name's case — "Co., Ltd." / "Co.,Ltd." / "Co.,
//     Limited" → "Company Limited"; "Part., Ltd." / "Part. Limited" / "Ltd., Part." → "Limited
//     Partnership" (the registered English form of a limited partnership); "Public Co., Ltd." / "PCL" →
//     "Public Company Limited" — and never in capitals: this box drops the company-name box's 'read in
//     capitals, written out in capitals'. "Ltd." alone, any other form, or none, stays as typed; a note
//     in brackets after the form, "(Head Office)", stays last.
//   · a name in another script (Thai) has no capitals and is left as typed. The server's copy also
//     writes out the country's own form on a Latin name ("บริษัท ACME จำกัด"); this one leaves it.
import { nameMarkersRe } from './statutory';
import { normalisePersonNamePart } from './personName';

const EN_FULL: [RegExp, string][] = [
  [/[\s,]*\b(?:public\s+(?:co|company)\.?\s*,?\s*(?:ltd|limited)|pcl)\.?$/i, 'Public Company Limited'],
  [/[\s,]*\b(?:co|company)\.?\s*,?\s*(?:ltd|limited)\.?$/i, 'Company Limited'],
  [/[\s,]*\b(?:(?:ltd|limited)\.?\s*,?\s*part(?:nership)?|part(?:nership)?\.?\s*,?\s*(?:ltd|limited))\.?$/i, 'Limited Partnership'],
];
const allCaps = (s: string): boolean => /\p{Lu}/u.test(s) && !/\p{Ll}/u.test(s);

export function accountNameInFull(raw: any): string {
  const n = String(raw == null ? '' : raw).replace(/\s+/g, ' ').trim();
  if (!n) return n;
  const mk = nameMarkersRe().exec(n);
  const marker = mk ? mk[0] : '';
  const base = mk ? n.slice(0, mk.index) : n;
  const en = EN_FULL.find(([re]) => re.test(base));
  const name = (en ? base.replace(en[0], '') : base).trim();
  if (!name) return n;   // a form alone is not a name
  const cased = allCaps(name) ? normalisePersonNamePart(name) : name;
  return `${cased}${en ? ` ${en[1]}` : ''}${marker}`;
}
